window.collect = require("collect.js")

import Vue from "vue"
import App from "./App.vue"
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"
import { TimeSelect } from "element-ui"
import VueContentPlaceholders from "vue-content-placeholders"
import VueMeta from "vue-meta"
import CKEditor from "@ckeditor/ckeditor5-vue2"
import { LMap, LTileLayer, LMarker } from "vue2-leaflet"
import { Icon } from "leaflet"

import router from "./router"
import vuetify from "./plugins/vuetify"
import axios from "./plugins/axios"
import store from "./plugins/store"
import MultiFiltersPlugin from "./plugins/multifilters"
import Adhesion from "@dahub/cadh-front/dist"

import "../src/assets/css/app.scss"
import "element-ui/lib/theme-chalk/index.css"
import "@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css"
import "leaflet/dist/leaflet.css"
import DatePlugin from "./plugins/date"

Vue.prototype.$global = new Vue({ data: { loading: false } })
Vue.prototype.$http = axios

Vue.component(TimeSelect.name, TimeSelect)
Vue.component("l-map", LMap)
Vue.component("l-tile-layer", LTileLayer)
Vue.component("l-marker", LMarker)

// Plugins
Vue.use(CKEditor)
Vue.use(Adhesion)
Vue.use(VueContentPlaceholders)
Vue.use(MultiFiltersPlugin)
Vue.use(VueMeta, { refreshOnceOnNavigation: true })
Vue.use(DatePlugin, { timezone: "Europe/Paris" })

let env = process.env.NODE_ENV
let user = store.getters["account/user"]

if (env !== "development" && env !== "local") {
  Sentry.init({
    enabled: true,
    dsn:
      "https://e8e9b4477ac64c348eaaf7e71d730b54@o59553.ingest.sentry.io/5245868",
    integrations: [
      new VueIntegration({ Vue, attachProps: true, logErrors: true }),
    ],
    environment: env,
  })

  Sentry.configureScope((scope) => {
    scope.setUser(user)
  })
}

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

new Vue({
  render: (h) => h(App),
  vuetify,
  store,
  router: router,
}).$mount("#app")
